// removed by extract-text-webpack-plugin
module.exports = {"need_photosesh":"_5fXtfrpklZ1mzNOvyVWyg","container":"_2cZM48xgBEVfyGO3kPdRPW","custom_image":"_1Drct4idSCal9392f8P9Ti","custom_card":"_3CdIamkr9PSXGw4kgOIkrY","custom_detail_light":"_2vKzP6L2tJURWucYoOKlEt","item":"yZ3npdW-fptxjmaYO2mAa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Mobile/mobile_need_photosesh.css
// module id = 3041
// module chunks = 0